<template>
    <footer class="footer">
        <!-- <div style="margin-top:40px;margin-bottom:60px;">
            <div class="tile is-ancestor">
                <div class="tile is-parent">
                    <article class="tile is-child box boks">
                        <table border="0">
                            <tr>
                                <td width="12%">
                                    <font-awesome-icon icon="map-pin" class="has-text-primary" />
                                </td>
                                <td>
                                    <p class="is-size-6-desktop has-text-weight-bold has-text-white">                            
                                        General Hotell
                                    </p>
                                </td>
                            </tr>                      
                            <tr>
                                <td></td>
                                <td>
                                    <p class="is-size-6-desktop is-size-7-touch has-text-white"> 
                                        Helgelandsmoen Næringspark
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <p class="is-size-6-desktop is-size-7-touch has-text-white"> 
                                        Regimentsveien 10
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <p class="is-size-6-desktop is-size-7-touch has-text-white"> 
                                        3512 Hønefoss
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <font-awesome-icon icon="phone-volume" class="has-text-primary" />
                                </td>
                                <td>
                                    <p class="is-size-6-desktop is-size-7-touch has-text-white"> 
                                        +47 32 16 00 00
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <font-awesome-icon icon="mail-bulk" class="has-text-primary" />   
                                </td>
                                <td>
                                    <p class="is-size-6-desktop"> 
                                        <a href="mailto:booking@generalhotell.no?Subject=Melding%20fra%20nettsiden" class="hvit">
                                            booking@generalhotell.no
                                        </a>
                                    </p>
                                    <p class="is-size-7 has-text-white">
                                        <em>General Hotell er en del av GL-Hotelldrift AS.<br/> Org.nr. 988 227 889 MVA.</em>
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </article>
                </div>
                <div class="tile is-parent">
                    <article class="tile is-child box boks">
                        <div class="columns is-mobile">
                            <div class="column is-one-third has-text-centered">
                                <a href="https://www.facebook.com/GeneralHotell/" target="_blank" alt="Besøk oss på Facebook" class="hvit">
                                    <font-awesome-icon :icon="['fab', 'facebook']" size="5x" />
                                </a>
                            </div>
                            <div class="column is-one-third has-text-centered">
                                <a href="https://www.instagram.com/generalhotell/" target="_blank" alt="Besøk oss på Instagram" class="hvit">
                                    <font-awesome-icon :icon="['fab', 'instagram']" size="5x" />
                                </a>
                            </div>
                            <div class="column is-one-third has-text-centered">           
                                <a href="https://www.linkedin.com/company/2444928/" target="_blank" alt="Besøk oss på LinkedIn" class="hvit">        
                                    <font-awesome-icon :icon="['fab', 'linkedin']" 
                                    size="5x" />
                                </a>
                            </div>
                        </div>
                        <div class="columns is-mobile">
                            <div class="column is-half has-text-centered">
                                <a href="https://www.youtube.com/channel/UCrGp1P_moGodNPKw1iSlt4g" target="_blank" alt="Besøk oss på YouTube" class="hvit">
                                    <font-awesome-icon :icon="['fab', 'youtube']" size="5x" />
                                </a>
                            </div>
                            <div class="column is-half has-text-centered">       
                                <a href="https://www.tripadvisor.com/Hotel_Review-g910719-d1951467-Reviews-General_Hotell-Honefoss_Ringerike_Municipality_Buskerud_Eastern_Norway.html" target="_blank" alt="Besøk oss på TripAdvisor" class="hvit">
                                    <font-awesome-icon :icon="['fab', 'tripadvisor']" size="5x" />
                                </a>
                            </div>
                        </div>
                    </article>
                </div>
                <div class="tile is-parent">
                    <article class="tile is-child box boks">
                        <div class="columns is-mobile">
                            <div class="column is-half has-text-centered has-text-primary">
                                <font-awesome-icon :icon="['fab', 'cc-visa']" size="5x" />
                            </div>
                            <div class="column is-half has-text-centered has-text-primary">
                                <font-awesome-icon :icon="['fab', 'cc-mastercard']" size="5x" />
                            </div>
                        </div>
                        <p class="has-text-centered">
                            <img src="../assets/images/illustrasjoner/miljofyrtaarn.svg" alt="Sertifisert som Miljøfyrtårn" width="100px">
                        </p>                        
                    </article>
                </div>
                <div class="tile is-parent">
                    <article class="tile is-child box boks">
                            <Newsletter></Newsletter>
                    </article>
                </div>
            </div>
        </div>         -->
        
        <!-- KEITH-VÅPEN -->
        <!-- Lag en kul onmouseover her -->
        <div class="content has-text-centered">
            <p>
                <a href="http:///www.paraproduksjoner.no" target="_blank" alt="Laget av paraproduksjoner">
                <img src="@/assets/images/crest_trans_330px_new.png" width="100px"  />
                </a>
            </p>
        </div>
    </footer>
</template>

<script>
// import Newsletter from '@/components/Newsletter.vue'

export default {
  name: 'Hjem',
  components: {
    // Newsletter
  }
}

</script>

<style scoped>


.footer {
    background-color: #000000;
}

.boks {
    background-color: #383838;
    border: 1px solid #ffffff;    
}

.hvit:hover {
    color: #ffffff;
}


</style>

